<app-loader></app-loader>
<!-- Patient Header Section -->
<div class="ipd-patient-header">
    <!-- Left Section: Back button, Avatar, Patient Info -->
    <div class="patient-header-left">
        <i-tabler name="arrow-left" class="icon-20 cursor-pointer" (click)="goBack()"></i-tabler>
        <div class="patient-avatar-container">
            <img class="patient-avatar" [src]="profileImagePathSrc" alt="Patient avatar"
                fallbackImage="assets/images/profile/user-1.jpg" />
        </div>

        <div class="patient-info-block">
            <h4 class="patient-name m-0" *ngIf="OpdData" (click)="viewPatientDetails(patientinfo)">{{
                OpdData.patientName }} ({{OpdData.patientNumber}})</h4>
            <div class="patient-meta" *ngIf="patientinfo">
                <span class="patient-age">{{patientinfo.age}}</span>
                <span class="patient-gender-badge" [ngClass]="patientinfo.gender === 'M' ? 'male' : 'female'">
                    {{getGenderName(patientinfo.gender)}}
                </span>
            </div>
        </div>
    </div>

    <!-- Right Section: OPD Details -->
    <div class="patient-header-right">
        <div class="opd-info-item" *ngIf="OpdData">
            <span class="opd-label">{{ 'LABEL.OPD_NO' | translate }}</span>
            <span class="opd-value opd-link" (click)="viewOPD(OpdData)">{{ OpdData.opdNumber }}</span>
        </div>
        <div class="opd-info-item" *ngIf="OpdData">
            <span class="opd-label">{{ 'LABEL.OPD_DATE' | translate }}</span>
            <span class="opd-value">{{ OpdData.opdDate | commonDate }}</span>
        </div>
        <div class="opd-info-item" *ngIf="doctorDetails">
            <span class="opd-label">{{ 'LABEL.DOCTOR' | translate }}</span>
            <span class="doctor-value">Dr. {{doctorDetails.firstName}}
                {{doctorDetails.lastName}}</span>
        </div>
    </div>
</div>

<!-- Action Buttons -->
<div class="ipd-action-buttons m-b-10">
    <button type="button" class="hdr-btn"
        (click)="printAdmissionPaper()">{{'BUTTON.BTN_ADMISSION_PAPER' |translate}}</button>
    <button type="button" class="hdr-btn" (click)="openOperationSummary()">{{
        'BUTTON.BTN_OPERATION_SUMMARY'|translate}}</button>
    <button *ngIf="!hasDischargeDate() || (dailyReports.length ?? 0)" type="button" class="hdr-btn" color="primary"
        (click)="openDayToDayDetails()">{{
        'ENTITY.DAY_REPORT' | translate }}</button>
    <button type="button" class="hdr-btn" (click)="openDischargeCard()">{{
        'BUTTON.BTN_DISCHARGE_CARD' | translate}}</button>
    <button *ngIf="patientinfo?.id && !hasDischargeDate()" type="button" class="hdr-btn" color="primary"
        (click)="openMedicalRecord()">{{
        'ENTITY.RECORD' | translate}}</button>
    <ng-container *ngIf="ipdData">
        <button type="button" class="hdr-btn" (click)="openMedicalCertificate()"
            *ngIf="ipdData.dischargeTime && ipdData.dischargeDate">{{
            'BUTTON.BTN_MEDICAL_CERTIFICATE' | translate}}</button>
    </ng-container>
    <button type="button" class="hdr-btn hdr-btn--primary" (click)="openBillDialog()"
        [disabled]="ipdData && !canGenerateBill(ipdData)">
        {{ 'ENTITY.BILL' | translate }}
    </button>
</div>

<mat-card class="cardWithShadow">
    <mat-card class="table-container m-0">
        <mat-card-content class="p-0">
            <div class="category-scroll">
                <div class="ipd-header">
                    <h3>{{ 'LABEL.IPD_DETAILS' | translate}}</h3>
                    <a mat-icon-button color="primary" (click)="printIPDAdmissionPaper()"
                        [matTooltip]="'Print Admission Paper'">
                        <i-tabler name="printer" class="icon-25 d-flex text-primary"></i-tabler>
                    </a>
                </div>
                <mat-divider></mat-divider>

                <!-- ROW 1 -->
                <div class="row" *ngIf="ipdData">
                    <div class="col-lg-6">
                        <div class="patient-details">
                            <div class="detail-item">
                                <label>{{ 'LABEL.IPD_NO' | translate}}:</label>
                                <span>{{ ipdData.ipdNumber }}</span>
                            </div>
                            <div class="detail-item">
                                <label>{{ 'LABEL.IPD_DATETIME' | translate}}:</label>
                                <span>{{ ipdData.ipdDate | commonDate }} / {{ ipdData.ipdTime|timeFormat
                                    }}</span>
                            </div>
                            <div class="detail-item">
                                <label>{{ 'LABEL.PROVISIONAL_DIAGNOSIS' | translate}}:</label>
                                <span>{{ ipdData.provisionalDiagnosis }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-6">
                        <div class="patient-details">
                            <div class="detail-item" *ngIf="ipdData.wardName">
                                <label>{{ 'ENTITY.WARD' | translate}}:</label>
                                <span>{{ ipdData.wardName }}</span>
                            </div>
                            <div class="detail-item" *ngIf="ipdData.roomTypeName">
                                <label>{{ 'LABEL.ROOM_TYPE_NO' | translate}}:</label>
                                <span>{{ ipdData.roomTypeName }} / {{ ipdData.roomNo }}</span>
                            </div>
                            <div class="detail-item" *ngIf="ipdData.bedNo">
                                <label>{{ 'LABEL.BED_NUMBER' | translate}}:</label>
                                <span>{{ ipdData.bedNo }}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Operation Summary Section -->
                <div class="ipd-header m-t-20" *ngIf="operationSummary">
                    <h3 class="ipd-title">{{ 'BUTTON.BTN_OPERATION_SUMMARY' | translate}}</h3>
                </div>
                <mat-divider class="m-t-10" *ngIf="operationSummary"></mat-divider>

                <div class="row" *ngIf="operationSummary">
                    <div class="col-lg-12">
                        <div class="patient-details">
                            <div class="detail-item" *ngIf="operationSummary.assistantDoctorName">
                                <label>{{ 'LABEL.ASSITANT_DOCTOR' | translate}}:</label>
                                <span>{{ operationSummary.assistantDoctorName }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" *ngIf="operationSummary">
                    <div class="col-lg-12">
                        <div class="patient-details">
                            <div class="detail-item" *ngIf="operationSummary.anesthetistName">
                                <label>{{ 'LABEL.ANESTHETIST' | translate}}:</label>
                                <span>{{ operationSummary.anesthetistName }}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row" *ngIf="operationSummary">
                    <div class="col-lg-12">
                        <div class="patient-details">
                            <div class="detail-item" *ngIf="operationSummary.natureOfTreatmentName">
                                <label>{{ 'LABEL.NATURE_OF_TREATMENT' | translate}}:</label>
                                <span>{{ operationSummary.natureOfTreatmentName }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" *ngIf="operationSummary">
                    <div class="col-lg-12">
                        <div class="patient-details">

                            <div class="detail-item" *ngIf="operationSummary.treatmentGiven">
                                <label>{{ 'LABEL.TREATMENT_GIVEN' | translate}}:</label>
                                <span>{{ operationSummary.treatmentGiven }}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Day Report Section -->
                <div class="ipd-header m-t-20" *ngIf="dailyReports.length">
                    <h3 class="ipd-title">{{ 'ENTITY.DAY_REPORT' | translate }}</h3>
                </div>
                <mat-divider class="m-t-10" *ngIf="dailyReports.length"></mat-divider>

                <div class="daily-report-table-wrap" *ngIf="dailyReports.length">
                    <table mat-table [dataSource]="dailyReports" class="w-100">
                        <ng-container matColumnDef="reportDate">
                            <th mat-header-cell *matHeaderCellDef>{{ 'LABEL.REPORT_DATE' | translate }}</th>
                            <td mat-cell *matCellDef="let report">{{ report.reportDate | commonDate }}</td>
                        </ng-container>

                        <ng-container matColumnDef="reportTime">
                            <th mat-header-cell *matHeaderCellDef>{{ 'LABEL.REPORT_TIME' | translate }}</th>
                            <td mat-cell *matCellDef="let report">
                                {{ report.reportTime ? (report.reportTime | timeFormat) : '-' }}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="summary">
                            <th mat-header-cell *matHeaderCellDef>{{ 'LABEL.DESCRIPTION' | translate }}</th>
                            <td mat-cell *matCellDef="let report">
                                <span class="daily-report-table-summary">{{ getDailyReportSummary(report) }}</span>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="actions">
                            <th mat-header-cell *matHeaderCellDef class="text-right daily-report-action-column">
                                {{ 'LABEL.ACTION_LABEL' | translate }}
                            </th>
                            <td mat-cell *matCellDef="let report" class="text-right daily-report-action-column">
                                <button mat-icon-button color="primary" (click)="openDailyReportDetail(report)"
                                    [matTooltip]="(hasDischargeDate() ? 'LABEL.VIEW_LABEL' : 'LABEL.EDIT') | translate">
                                    <i-tabler [name]="hasDischargeDate() ? 'eye' : 'edit'"
                                        class="icon-20 d-flex"></i-tabler>
                                </button>
                            </td>
                        </ng-container>


                        <tr mat-header-row *matHeaderRowDef="dailyReportDisplayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: dailyReportDisplayedColumns;"></tr>
                    </table>
                </div>

                <!-- Discharge Card Section -->
                <ng-container *ngIf="ipdData">
                    <div class="ipd-header m-t-20" *ngIf="ipdData.dischargeTime && ipdData.dischargeDate">
                        <h3 class="ipd-title">{{ 'BUTTON.BTN_DISCHARGE_CARD' | translate }}</h3>
                        <a mat-icon-button color="primary" (click)="printDischarge()"
                            [matTooltip]="'Print Discharge Paper'">
                            <i-tabler name="printer" class="icon-25 d-flex text-primary"></i-tabler>
                        </a>
                    </div>

                    <mat-divider *ngIf="ipdData.dischargeTime && ipdData.dischargeDate">
                    </mat-divider>
                </ng-container>
                <div class="row" *ngIf="ipdData">
                    <div class="col-lg-12">
                        <div class="patient-details">
                            <div class="detail-item" *ngIf="ipdData.dischargeDate && ipdData.dischargeTime">
                                <label>{{ 'LABEL.DISCHARGE_DATETIME' | translate}}:</label>
                                <span>{{ ipdData.dischargeDate | commonDate }} / {{
                                    ipdData.dischargeTime|timeFormat }}</span>
                            </div>
                        </div>
                    </div>
                </div>


                <div class="row" *ngIf="ipdData">
                    <div class="col-lg-12">
                        <div class="patient-details">
                            <div class="detail-item" *ngIf="ipdData.finalDiagnosis">
                                <label>{{ 'LABEL.FINAL_DIAGNOSIS' | translate}}:</label>
                                <span>{{ ipdData.finalDiagnosis }}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row" *ngIf="ipdData">
                    <div class="col-lg-12">
                        <div class="patient-details">
                            <div class="detail-item" *ngIf="ipdData.treatmentAdvice">
                                <label>{{ 'LABEL.TREATMENT_ADVICE' | translate}}:</label>
                                <span>{{ ipdData.treatmentAdvice }}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="ipd-header m-t-20" *ngIf="medicalRecordCount !== 0">
                    <h3 class="ipd-title">{{'ENTITY.RECORD' | translate}}</h3>
                </div>
                <mat-divider class="m-t-10" *ngIf="medicalRecordCount !== 0"></mat-divider>
                <app-medical-record *ngIf="patientinfo" [patientId]="patientinfo.id" [type]="'IPD'"
                    [hidden]="medicalRecordCount === 0"
                    (medicalRecordLength)="onMedicalRecordLength($event)"></app-medical-record>

            </div>
        </mat-card-content>
    </mat-card>

</mat-card>

<div [hidden]="true">
    <app-ipd-discharge #reportPrintComponent [patientDetails]="patientinfo" [opdDetails]="OpdData"
        [ipdData]="ipdData"></app-ipd-discharge>
</div>
